import styleConstants from 'widgets/portfolioReturns/variables.module.scss';
import { useWidgetContext } from 'widgets/WidgetContext';
import { usePortfolioReturnsConfigSlice } from 'widgets/portfolioReturns/store/configuration/configSlice';
import { usePortfolioReturnsLegendStatus } from 'widgets/portfolioReturns/legends/legendStatus';

export function usePortfolioReturnsDimensions() {
    const { height } = useWidgetContext();

    const { config } = usePortfolioReturnsConfigSlice();
    const { hideToolbar, hideTitlePanel } = config;

    const { allHidden } = usePortfolioReturnsLegendStatus();

    if (allHidden && hideToolbar) {
        return { chartHeight: height, headerHeight: 0 };
    }

    const headerHeight = allHidden
        ? parseInt(styleConstants.toolbarHeight)
        : parseInt(styleConstants.legendHeight);
    const headerHeightWithPadding =
        headerHeight + parseInt(styleConstants.legendMarginBottom);

    let chartHeight =
        height -
        headerHeightWithPadding -
        parseInt(styleConstants.paddingVertical) * 3;

    chartHeight = hideTitlePanel ? chartHeight : chartHeight - 22;

    return { chartHeight, headerHeight: headerHeightWithPadding };
}
